import React, { useCallback, useState } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import DocumentHeadTags from 'components/document-head-tags'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import ModalDialog from 'components/ui/modal-dialog'
const SORT_OPTIONS = [
  {
    value: 'custom',
    label: 'Custom (default)',
  },
  {
    value: 'artist;asc',
    label: 'Artist: A-Z',
  },
  {
    value: 'track_title;asc',
    label: 'Track title: A-Z',
  },
  {
    value: 'date_added;desc',
    label: 'Date added: Newest to oldest',
  },
  {
    value: 'date_added;asc',
    label: 'Date added: Oldest to newest',
  },
  {
    value: 'year;desc',
    label: 'Year: Newest to oldest',
  },
  {
    value: 'year;asc',
    label: 'Year: Oldest to newest',
  },
  {
    value: 'tracknumber;asc',
    label: 'Track order: Ascending',
  },
]
type Props = {
  currentSorting: string
  progressIndicator?: boolean
  onChange: (...args: Array<any>) => any
  onClose: (...args: Array<any>) => any
}

const TrackOrderModal = ({
  currentSorting = 'custom',
  progressIndicator,
  onChange,
  onClose,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const [sorting, setSorting] = useState<string>(currentSorting)
  const handleSortChange = useCallback(option => {
    setSorting(option.value)
  }, [])
  const handleSubmit = useCallback(() => {
    const order = SORT_OPTIONS.find(option => option.value === sorting)?.label

    if (order) {
      dispatch(sendMixpanelEvent(`Change track order - ${order}`))
    }

    onChange(...sorting.split(';'))
  }, [dispatch, sorting, onChange])
  return (
    <ModalDialog
      title="Change track order"
      primaryAction={{
        caption: 'Update',
        progressCaption: 'Updating',
        progressIndicator,
        onClick: handleSubmit,
      }}
      onCancel={onClose}
    >
      <DocumentHeadTags title="Change track order | DISCO" />
      <CustomDropdown
        autoFocus
        options={SORT_OPTIONS}
        value={sorting}
        onChange={handleSortChange}
      />
    </ModalDialog>
  )
}

export default TrackOrderModal
